'use strict';

import I18n from 'i18n-js';
import en from '../../../../config/locales/en.yml';
import de from '../../../../config/locales/de.yml';
import fr from '../../../../config/locales/fr.yml';
import it from '../../../../config/locales/it.yml';

// Each locale file has the locale as its top-level key
I18n.translations = { ...en, ...de, ...fr, ...it };

export default I18n;
